import quoteGQLString from '../util/quoteGQLString';
import patentLostHistory from '../type/patentLostHistory';

export default (orgId) => `
    patentLostByOrg(org: ${quoteGQLString(orgId)}) {
        ${patentLostHistory()}
    }
`;
